module.exports = __webpack_public_path__ + "static/img/81-3.76d4d5a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/81-3.jpg
// module id = i+/7
// module chunks = 0